import processNumber from "../process-number";

/**
 *
 * @param {String} input
 * @param {String} separator
 */
const processRGBA = (input, separator) => {
  const space = /[▂|▃]/.test(input);

  /** Remove 'rgb' or 'rgba' prefix and parentheses */
  const color = input.slice(input.indexOf("(") + 1, -1).trim();

  /** Split into channels based on spaces or slashes */
  const channels = space ? color.split(/[▂|▃/]+/) : color.split(separator);

  /** Extract r, g, b, and a (if it exists) */
  const chR = channels[0];
  const chG = channels[1];
  const chB = channels[2];
  const chA = channels[3];

  const r = chR === "?" ? "?" : chR;
  const g = chR === "?" ? "?" : chG;
  const b = chR === "?" ? "?" : chB;

  let a = "1";

  if (chA && chA !== "?") {
    const isComposition = chA.startsWith("◖");
    const composition = isComposition ? chA.slice(0, 3) : "";
    const pure = isComposition ? chA.replace(composition, "") : chA;

    if (space) {
      a = `${composition}${+pure.slice(0, -1) / 100}`;
    } else {
      a = `${composition}${+pure}`;
    }
  }

  /** Return in standard rgba() format */
  return `rgba(${r}${separator}${g}${separator}${b}${separator}${a})`;
};

export default processRGBA;
